<template>
  <form @submit.prevent="onSubmit" class="c-folder-properties">
    <p4a-tabs v-if="folderInfo" v-model="tabsModel.model" :vertical="tabsModel.vertical" >
      <p4a-tab :name="tabsModel.tabs.general.name" :value="tabsModel.tabs.general.value">
        <general :general="general"
                 :ReadOnly="ReadOnly"
                 :CanChangeProject.sync="CanChangeProject"
                 :CanChangeMetadataSet="CanChangeMetadataSet"
                 :currentProject="currentProject"
                 :disableUnlinkProject.sync="disableUnlinkProject"
                 :snagstreamProjects="snagstreamProjects">
        </general>
      </p4a-tab>
      <p4a-tab :name="tabsModel.tabs.procedure.name" :value="tabsModel.tabs.procedure.value">
        <procedure :procedure="procedure" :ReadOnly="ReadOnly"></procedure>
      </p4a-tab>
      <p4a-tab :name="tabsModel.tabs.requiredDocuments.name" :value="requiredDocuments">
        <requiredDocuments :requiredDocuments="requiredDocuments" :ReadOnly="ReadOnly"></requiredDocuments>
      </p4a-tab>
    </p4a-tabs>
    <!-- buttons -->
    <div class="buttons-row">
      <p4a-button
        @click="closeWindow"
        :onlyIconVisible="false"
        :size="'large'"
        :product="'ts'"
        :disable="false"
        :text="$t('general.cancel')">
      </p4a-button>
      <p4a-button
        @click="onSubmit"
        class="saveButton"
        :onlyIconVisible="false"
        :product="'ds'"
        :size="'large'"
        value="Submit"
        :disable="ReadOnly"
        :text="$t('general.save')">
      </p4a-button>
    </div>
  </form>
</template>

<script>
import mixins from 'mixins'
import _ from 'lodash'

import * as treemenuApi from 'api/treemenuApi'

import general from './folderProperties/generalProperties'
import procedure from './folderProperties/procedure'
import requiredDocuments from './folderProperties/requiredDocuments'

export default {
  mixins: [mixins],
  components: { general, procedure, requiredDocuments },
  data () {
    return {
      selectedIntegerId: null,
      folderInfo: null,
      sets: [],
      projects: [],
      currentProject: {},
      templates: [],
      users: [],
      ReadOnly: false,
      CanChangeProject: true,
      CanChangeMetadataSet: true,
      disableUnlinkProject: false,
      general: {
        Name: '',
        CreatedBy: '',
        CreationDate: '',
        FolderContents: [],
        metaDataSet: {
          selected: '',
          items: []
        },
        project: {
          selected: '',
          items: []
        },
        IsProjectFolder: false,
        IsConfidentialFolder: false
      },
      procedure: {
        AutoProcedureEnabled: false,
        template: {
          selected: '',
          items: []
        },
        owner: {
          selected: '',
          items: []
        }
      },
      requiredDocuments: {
        textareaText: ''
      },
      snagstreamProjects: null,
      tabsModel: {
        model: 'dashboard',
        vertical: false,
        tabs: {
          general: {
            name: this.$t('folderProperties.general.title'),
            value: 'dashboard'
          },
          procedure: {
            name: this.$t('folderProperties.procedure.title'),
            value: 'procedure'
          },
          requiredDocuments: {
            name: this.$t('folderProperties.requiredDocuments.title'),
            value: 'requiredDocuments'
          }
        }
      }
    }
  },
  created () {
    const selectedIntegerId = this.$route.params.id
    this.selectedIntegerId = selectedIntegerId
    treemenuApi.getSnagstreamProjects(selectedIntegerId).then(snagstreamProjects => {
      this.snagstreamProjects = snagstreamProjects
      if (this.snagstreamProjects) {
        this.snagstreamProjects.unshift({
          '<Name>k__BackingField': this.$i18n.t('folderProperties.general.form.notLinked'),
          '<ProjectId>k__BackingField': null
        })
      }
    })
    treemenuApi.getFolderInfo(selectedIntegerId).then(data => {
      // store data
      this.folderInfo = data
      this.ReadOnly = data.ReadOnly
      this.CanChangeProject = data.CanChangeProject
      this.CanChangeMetadataSet = data.CanChangeMetadataSet
      // General
      this.getGeneral(data)

      // Procedure
      this.getProcedure(data)

      // requiredDocuments
      this.getRequiredDocuments(data)
    })
  },
  methods: {
    getGeneral (data) {
      data.RequiredItems = data.RequiredItems.join('\r\n')
      this.general = _.merge({}, this.general, data)
      treemenuApi.getFolderMetaSets().then(dataSets => {
        this.sets = dataSets
        const selectedSet = _.find(dataSets, set => set.PropertyDefinitionSetId === data.MetadataSetId)
        const setNames = _.map(dataSets, 'Name')
        if (selectedSet) this.general.metaDataSet.selected = selectedSet.Name
        this.general.metaDataSet.items = setNames
      })
      treemenuApi.getFolderProjects().then(projects => {
        this.currentProject = {FolderId: this.selectedIntegerId, ProjectId: data.ProjectFolderId}
        projects.unshift({ProjectId: data.ProjectFolderId, Name: data.ProjectFolderName})
        if (!data.ProjectFolderId) {
          this.disableUnlinkProject = true
        } else {
          this.CanChangeProject = false
        }
        this.projects = projects
        const selectedProject = _.find(projects, project => project.ProjectId === data.ProjectFolderId)
        const projectNames = _.map(projects, 'Name')
        if (selectedProject) this.general.project.selected = selectedProject.Name
        this.general.project.items = projectNames
      })
    },
    getProcedure (data) {
      this.procedure.AutoProcedureEnabled = data.AutoProcedureEnabled
      treemenuApi.getTemplates().then(templates => {
        this.templates = templates
        const selectedTemplate = _.find(templates, template => template.ProcedureTemplateId === data.AutoProcedureId)
        const templateNames = _.map(templates, 'ProcedureTemplateName')
        if (selectedTemplate) this.procedure.template.selected = selectedTemplate.ProcedureTemplateName
        this.procedure.template.items = templateNames
      })
      treemenuApi.getUsers().then(users => {
        this.users = users
        const selectedUser = _.find(users, user => user.PrivilegizedEntityId === data.AutoProcedureOwner)
        const userNames = _.map(users, 'Name')
        if (selectedUser) this.procedure.owner.selected = selectedUser.Name
        this.procedure.owner.items = userNames
      })
    },
    getRequiredDocuments (data) {
      this.requiredDocuments.textareaText = data.RequiredItems
    },
    closeWindow () {
      window.close()
    },
    onSubmit () {
      // Validate folderName
      if (!this.validFolderName(this.general.Name)) return

      // Get MetadataSetId
      const selectdSetName = this.general.metaDataSet.selected
      let MetadataSetId = ''
      if (selectdSetName) {
        MetadataSetId = _.find(this.sets, set => set.Name === selectdSetName).PropertyDefinitionSetId
      }
      // Get ProjectFolderId
      const selectdProjectName = this.general.project.selected
      let ProjectFolderId = null
      if (selectdProjectName) {
        ProjectFolderId = _.find(this.projects, project => project.Name === selectdProjectName).ProjectId
      }
      // Get AutoProcedureId
      const selectdProcedureName = this.procedure.template.selected
      let AutoProcedureId = 0
      if (selectdProcedureName) {
        AutoProcedureId = _.find(this.templates, template => template.ProcedureTemplateName === selectdProcedureName).ProcedureTemplateId
      }
      // Get AutoProcedureOwner
      const ownerName = this.procedure.owner.selected
      let AutoProcedureOwner = -1
      if (ownerName) {
        AutoProcedureOwner = _.find(this.users, user => user.Name === ownerName).PrivilegizedEntityId
      }
      // Get Required Documents Items
      const requiredItems = this.requiredDocuments.textareaText.split('\r\n')

      const body = {
        Name: this.general.Name,
        Comment: this.folderInfo.Comment,
        RightsDescription: this.folderInfo.RightsDescription,
        ParentFolderId: this.folderInfo.RightsDescription,
        CreationDate: this.general.CreationDate,
        CreatedBy: this.general.CreatedBy,
        HasSubfolders: this.folderInfo.HasSubfolders,
        FolderContents: this.general.FolderContents,
        IsProjectFolder: this.general.IsProjectFolder,
        IsConfidentialFolder: this.general.IsConfidentialFolder,
        AutoProcedureId: AutoProcedureId,
        AutoProcedureOwner: AutoProcedureOwner,
        AutoProcedureEnabled: this.procedure.AutoProcedureEnabled,
        SnagstreamProjectId: this.general.SnagstreamProjectId,
        RequiredItems: requiredItems
      }
      const vm = this;
      (async function postData () {
        await treemenuApi.postFolderInfo(vm.selectedIntegerId, body)
        if (MetadataSetId && vm.CanChangeMetadataSet) {
          await treemenuApi.postMetadataSet({FolderId: vm.selectedIntegerId, PropertySetId: MetadataSetId})
        }
        if (ProjectFolderId && vm.folderInfo.ProjectFolderId !== ProjectFolderId && vm.CanChangeProject) {
          await treemenuApi.postProject({FolderId: vm.selectedIntegerId, ProjectId: ProjectFolderId})
        }
        vm.reloadIframe('updateTreeView')
        vm.closeWindow()
      })()
    }
  }
}
</script>

<style lang="scss" >
</style>



// WEBPACK FOOTER //
// src/components/folder/folderProperties.vue